export default "__VITE_ASSET__84244d18__"